<template>
  <div row id="row">
    <v-flex xs12 md6 v-for="email in invited_member_emails" :key="email.name">
      <v-text-field
        type="email"
        label="メールアドレス"
        v-model="email.id"
        :name="`invited_member_emails[${email.name}]`"
      ></v-text-field>
    </v-flex>
    <v-btn
      id="add-email"
      class="v-btn theme--light btn-big"
      @click="addMailAddress()"
      >追加で招待する</v-btn
    >
  </div>
</template>

<script>
export default {
  props: ["addInputEmailCount"],
  data: function() {
    return {
      invited_member_emails: [],
    };
  },

  methods: {
    addMailAddress: function() {
      // メールアドレスの行を追加する
      var currentIndex = this.invited_member_emails.length + 5;
      for (var i = 0; i < 5; i++) {
        this.invited_member_emails.push({ name: currentIndex + i });
      }
    },
  },

  mounted() {
    // 初期値5, addInputEmailCountが5以上の場合はそちらを代入
    const target =
      parseInt(this.addInputEmailCount) < 5
        ? 5
        : parseInt(this.addInputEmailCount);

    for (var i = 0; i < target; i++) {
      this.invited_member_emails.push({
        name: parseInt(this.addInputEmailCount) + i,
      });
    }
  },
};
</script>
